export default __webpack_public_path__ + "static/media/factory_icon.4127d7fc.svg";